let fetch_admin_settings = 1;

export const getAdminOption = () => fetch_admin_settings;
export const setAdminOption = (settings) => {
  fetch_admin_settings = settings;
};
